<template>
    <el-dialog
        title="更新释放状态"
        width="600px"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'updateReleaseStatusDialog'"
        >
        <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px">
            <el-form-item label="供应商：" prop="supplier">
                <el-select style="width: 380px" :disabled="true" v-model="formData.supplier" placeholder="请选择供应商">
                    <el-option
                        v-for="item in supplierOptionList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div class="update-release-status-dialog-tips">注：更新释放状态为“释放中”的数据。解冻释放状态变更为“已释放”后的费用，可以在美的付发起提现</div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" :loading="btnLoading" @click="handleSubmit">更新释放状态</el-button>
        </div>
    </el-dialog>
</template>

<script>
import { updateThawingStatus } from '@/modules/transport/otp/api/driverExpenseUnfreezeAndBalance.js';
export default {
    name: 'updateReleaseStatusDialog',
    props: {
        supplier: {
            type: Object,
            default: () => {}
        }
    },
    data () {
        return {
            btnLoading: false,
            formData: {
                supplier: ''
            },
            rules: {
                supplier: [
                    {
                        required: true,
                        message: '请选择供应商',
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    computed: {
        supplierOptionList() {
            return [
                {
                    label: this.supplier.supplierNameCn,
                    value: this.supplier.supplierCode
                }
            ]
        }
    },
    async mounted () {
        this.formData.supplier = this.supplier.supplierCode
    },
    methods: {
        /**
         * @description 关闭
         */
        beforeClose () {
            this.$emit('update:updateReleaseStatusDialogShow', false);
        },
        /**
         * @description 提交
         */
        handleSubmit () {
            this.$refs.formRef.validate(valid => {
                if (valid) {
                    this.btnLoading = true;
                    updateThawingStatus({
                        carrierCode: this.supplier.supplierCode
                    }).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success(res.data);
                            this.$emit('refresh')
                        }
                    }).catch(() => {
                    }).finally(() => {
                        this.btnLoading = false
                        this.beforeClose()
                    })
                    
                };
            });
        }
    }
};
</script>

<style lang="less">
.updateReleaseStatusDialog{
    .el-dialog__body {
        padding: 16px 36px 16px 16px;
    }
    .update-release-status-dialog-tips {
        color: #D9001B;
    }
}
</style>
